import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import notify, { MESSAGES } from '../../../utils/notify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { unwrapImprovementClarificationDetail } from '../utils/improvementClarificationHelpers';

const useImprovementClarificationDetail = procurementId => {
  const [item, setItem] = useState(null);
  const [isLoading, setIsLoading] = useState(Boolean(procurementId));
  const [error, setError] = useState(null);

  const fetchDetail = useCallback(async () => {
    if (!procurementId) {
      setIsLoading(false);
      return;
    }

    const token = getAuthToken();
    if (!token) {
      notify.error(MESSAGES.authRequired);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${api.API_URL}/procurement/${procurementId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        }
      );
      setItem(unwrapImprovementClarificationDetail(response));
    } catch (err) {
      const message =
        typeof err === 'string'
          ? err
          : 'Failed to load improvement clarification detail';
      setError(message);
      setItem(null);
      notify.apiError(err, 'load improvement clarification detail');
    } finally {
      setIsLoading(false);
    }
  }, [procurementId]);

  useEffect(() => {
    fetchDetail();
  }, [fetchDetail]);

  return {
    item,
    isLoading,
    error,
    refresh: fetchDetail,
  };
};

export default useImprovementClarificationDetail;
